module.exports = __webpack_public_path__ + "static/media/plus_w.73bab8e9.svg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/CarEditorPage/components/carActiveMenu/img/plus_w.svg
// module id = 1660
// module chunks = 0